import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const FB_RESULT_KEY = "postpintar-fb-connect";

export default function FbDone() {
  const navigate = useNavigate();
  const status = new URLSearchParams(window.location.search).get("fb") || "gagal";
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    localStorage.setItem(FB_RESULT_KEY, JSON.stringify({ status, t: Date.now() }));
    if (window.opener) {
      try { window.opener.postMessage({ type: "fb-connect", status }, window.location.origin); } catch { /* opener severed */ }
    }
    window.close();
    const t = setTimeout(() => (window.opener || window.name === "fb-connect" ? setStuck(true) : navigate(`/tetapan?fb=${status}`, { replace: true })), 600);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const ok = status === "ok" || status === "pilih";
  return (
    <div className="relative z-10 flex min-h-screen items-center justify-center p-6" data-testid="fb-done-page">
      {stuck && (
        <div className="panel max-w-sm p-8 text-center">
          {ok ? <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-400" /> : <XCircle className="mx-auto h-10 w-10 text-red-400" />}
          <p className="mt-4 font-semibold">{ok ? "Facebook berjaya disambung" : "Sambungan tidak berjaya"}</p>
          <p className="mt-2 text-sm text-muted-foreground">Anda boleh tutup tetingkap ini dan kembali ke PostPintar.</p>
          <div className="mt-5 flex justify-center gap-2">
            <Button onClick={() => window.close()} data-testid="fb-done-close-btn">Tutup tetingkap</Button>
            <Button variant="secondary" asChild><Link to={`/tetapan?fb=${status}`}>Ke Tetapan</Link></Button>
          </div>
        </div>
      )}
    </div>
  );
}
